export default __webpack_public_path__ + "static/media/new-light.5c3e5cef.svg";